/**
 * Hide first consent checkbox in Shopify Forms app
 * Handles shadow DOM which CSS cannot penetrate
 */
(function() {
  'use strict';

  function hideFirstConsentCheckbox() {
    document.querySelectorAll('shopify-forms-embed').forEach(embed => {
      const shadowRoot = embed.shadowRoot;
      
      if (shadowRoot) {
        const form = shadowRoot.querySelector('form[class*="formFieldset"]');
        if (form) {
          // Find and hide the first consent checkbox
          const consentCheckboxes = form.querySelectorAll('[class*="consentCheckboxContainer"]');
          if (consentCheckboxes.length > 0) {
            const firstCheckbox = consentCheckboxes[0];
            if (firstCheckbox instanceof HTMLElement) {
              firstCheckbox.style.display = 'none';
            }
          }
          
          // Inject CSS as backup
          if (!shadowRoot.querySelector('style[data-hide-first-consent]')) {
            const style = document.createElement('style');
            style.setAttribute('data-hide-first-consent', 'true');
            style.textContent = `
              form[class*="formFieldset"] [class*="consentCheckboxContainer"]:first-of-type {
                display: none !important;
              }
            `;
            shadowRoot.appendChild(style);
          }
        }
      }
    });
  }

  // Run on load and watch for dynamically loaded forms
  hideFirstConsentCheckbox();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideFirstConsentCheckbox);
  }

  const observer = new MutationObserver(() => {
    hideFirstConsentCheckbox();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
